/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDevicesPc = createReactComponent("devices-pc", "IconDevicesPc", [
  ["path", { d: "M3 5h6v14h-6z", key: "svg-0" }],
  ["path", { d: "M12 9h10v7h-10z", key: "svg-1" }],
  ["path", { d: "M14 19h6", key: "svg-2" }],
  ["path", { d: "M17 16v3", key: "svg-3" }],
  ["path", { d: "M6 13v.01", key: "svg-4" }],
  ["path", { d: "M6 16v.01", key: "svg-5" }]
]);

export { IconDevicesPc as default };
//# sourceMappingURL=IconDevicesPc.js.map
